import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  levels2: [],
  status: "idle",
  error: null,
};

export const levels2Slice = createSlice({
  name: "levels2",
  initialState,
  reducers: {
    levels2Requested: (state) => {
      state.status = "loading";
    },
    levels2RequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    levels2RequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.levels2 = action.payload;
    },
  },
});

export const {
  levels2Requested,
  levels2RequestFailed,
  levels2RequestSucceeded,
} = levels2Slice.actions;

export default levels2Slice.reducer;
